import { EAgentExecutionStatus } from '@/types/agents';

import StandardBadge from '../StandardBadge/StandardBadge';

const statusConfig = {
  [EAgentExecutionStatus.SUCCESS]: { colorScheme: 'green.700', label: 'Success' },
  [EAgentExecutionStatus.FAILED]: { colorScheme: 'red.700', label: 'Failed' },
  [EAgentExecutionStatus.IN_PROGRESS]: { colorScheme: 'blue.700', label: 'In Progress' },
};

const StatusBadge = ({ status }: { status?: EAgentExecutionStatus }) => {
  if (!status) {
    return null;
  }

  const config = statusConfig[status] || { colorScheme: 'gray.700', label: 'Unknown' };

  return (
    <StandardBadge
      borderColor="green.100"
      backgroundColor={config.colorScheme}
      variant="solid"
      color="white"
    >
      {config.label}
    </StandardBadge>
  );
};

export default StatusBadge;